// npm i @glidejs/glide --save

// https://glidejs.com/docs/

{/* <div class="glide">
  <div class="glide__track" data-glide-el="track">
    <ul class="glide__slides">
      <li class="glide__slide">0</li>
      <li class="glide__slide">1</li>
      <li class="glide__slide">2</li>
    </ul>
  </div>
</div> */}

import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-glide').forEach((carousel) => {
    const glide = new Glide(carousel, {
      type: 'carousel',
      autoplay: 2000,
      animationDuration: 800,
    });
    glide.on(['mount.after', 'move'], () => {
      const currentSlide = document.querySelector('.glide__slide[data-index="' + glide.index + '"]');
      if (!currentSlide) {
        return;
      }

      const container = carousel.closest('.js-glide-container');
      container.querySelector('.js-glide-legend').innerHTML = currentSlide.dataset.legend || '&nbsp;';
      container.querySelector('.js-glide-counter').textContent = `${glide.index + 1}/${carousel.dataset.total}`;
    });
    glide.mount();
  });
});
